module.exports = __webpack_public_path__ + "static/media/appStore.fdbc3f89.png";